/* Brightside sale prices: show a Card sale's price only while the sale is on.
   Anything in a sale carries data-bs-card-sale="start|end" (seconds): product cards, the product page
   price and recipe-page tiles. Pages can be cached from before a sale started or after it ended, so the
   browser's clock decides, and things added later (filters, sorting, "load more") are checked too.
   Markup: snippets/product-tile.liquid, bs-card-price.liquid, bs-live-price.liquid, bs-sale-lookup.liquid. */
(function () {
  if (window.BrightsideCards) return;
  window.BrightsideCards = true;

  function check() {
    var now = Date.now() / 1000;
    var els = document.querySelectorAll('[data-bs-card-sale]');
    for (var i = 0; i < els.length; i++) {
      var t = els[i].getAttribute('data-bs-card-sale').split('|');
      var start = parseFloat(t[0]) || 0;
      var end = parseFloat(t[1]) || 0;
      els[i].classList.toggle('is-sale-live', now >= start && now < end);
    }
  }

  check();
  document.addEventListener('DOMContentLoaded', check);
  if ('MutationObserver' in window) {
    var wait;
    new MutationObserver(function () {
      clearTimeout(wait);
      wait = setTimeout(check, 60);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  setInterval(check, 60000);
})();
